import { formatDateParams, formatCurrency } from 'shared/utils';
import { Button, Card, Col, Row } from 'react-bootstrap';

export const CardDetails = (props: {
  cardData: any;
  goToAccountMovements(): void;
  goBack(): void;
  searchParams: URLSearchParams;
}) => {
  return (
    <Card>
      <Card.Header className="text-center">
        {props.cardData.denominacionCuenta}
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <p className="fw-semibold">
              Centro costo padre: {props.cardData.centroCostoPadre}
            </p>
          </Col>
          <Col>
            <p className="fw-semibold">Nro. Cuenta: {props.cardData.cuentaOrigen}</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="fw-semibold">
              Denominación cuenta tarjeta:
              {' ' + props.cardData.denominacionTarjeta}
            </p>
          </Col>
          <Col>
            <p className="fw-semibold">
              Saldo inicial: {formatCurrency(props.cardData.saldo)}
            </p>
          </Col>
        </Row>
        <p className="fw-semibold text-center">
          Movimientos Tarjeta: {props.cardData.numeroTarjeta}
        </p>
        <p className="fw-semibold text-center">{formatDateParams(props.searchParams)}</p>
        <Row>
          <Col className="text-center">
            <Button
              className="me-2"
              variant="secondary"
              onClick={props.goToAccountMovements}
            >
              Ver movimientos de la cuenta
            </Button>
            <Button variant="secondary" onClick={props.goBack}>
              Volver
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
